import { useCallback, useRef } from 'react';

type AnyCallback = (...args: any[]) => any;

/**
 * Returns a stable function reference that always calls the latest
 * version of the provided callback.
 */
export const useStableCallback = <T extends AnyCallback>(callback: T): T => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(((...args: Parameters<T>) => callbackRef.current(...args)) as T, []);
};
